// 组件配置模板
// 数字代表一个类型组件的ID
console.log('⚙️ moduleConfig 文件被加载！');
var moduleConfig = {
  1: {
    modultName: "枚举",
    type: "enum"
  },
  2: {
    modultName: "下来枚举",
    type: "dow-enum" // "dow-enum",
  },

  3: {
    modultName: "下拉",
    type: "select"
  },
  4: {
    modultName: "级联",
    type: "cascade"
  },
  5: {
    modultName: "下拉树",
    type: "dropTree"
  },
  6: {
    modultName: "下拉表格",
    type: "dropTable"
  },
  7: {
    modultName: "自定义>=<≥",
    type: "custom"
  },
  8: {
    modultName: "日期时间",
    type: "date"
  },
  9: {
    modultName: "输入",
    type: "input",
    api: ""
  }
};
export default moduleConfig;